var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { makeStyles, ThemeProvider } from '@material-ui/core/styles';
import { DefaultTemplate } from './layout/DefaultTemplate';
import { DefaultNoIssuerTemplate } from './layout/DefaultNoIssuerTemplate';
import { ProductTemplate } from './layout/ProductTemplate';
import { ProductNoIssuerTemplate } from './layout/ProductNoIssuerTemplate';
import { BigShopNameTemplate } from './layout/BigShopNameTemplate';
export var useCommonStyles = makeStyles(function (theme) { return ({
    section: {
        marginTop: theme.spacing(1),
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    image: {
        width: '100%',
        height: '100%',
    },
}); });
/**
 * Atomic Design における本来の意味合いでの Template とは意味合いが異なるかもしれないが、気にしない
 */
export var AvailableTemplate = function (props) {
    var theme = props.theme, layoutPattern = props.layoutPattern, data = __rest(props, ["theme", "layoutPattern"]);
    var switchLayoutTemplate = function (layout) {
        switch (layout) {
            case 'normal':
                return React.createElement(DefaultTemplate, __assign({}, data));
            case 'normalNoIssuer':
                return React.createElement(DefaultNoIssuerTemplate, __assign({}, data));
            case 'product':
                return React.createElement(ProductTemplate, __assign({}, data));
            case 'productNoIssuer':
                return React.createElement(ProductNoIssuerTemplate, __assign({}, data));
            case 'bigShopName':
                return React.createElement(BigShopNameTemplate, __assign({}, data));
            default:
                return React.createElement(DefaultTemplate, __assign({}, data));
        }
    };
    return React.createElement(ThemeProvider, { theme: props.theme }, switchLayoutTemplate(layoutPattern));
};
//# sourceMappingURL=AvailableTemplate.js.map